export class Validation {
    static isValidCrop(crop) {
        return crop && crop.width > 0 && crop.height > 0;
    }
}
